import React from 'react';
import HistorySection from './history/HistorySection';
import HistoryNav from './history/HistoryNav';
import HistoryMobileNav from './history/HistoryMobileNav';

class HistoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vWidth: window.innerWidth,
      vHeight: window.innerHeight,
      modalOpen: false,
    }
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange() {
    this.setState({ vWidth: window.innerWidth, vHeight: window.innerHeight });
  }

  render() {
    const {historyData} = this.props;
    const {vWidth, vHeight} = this.state;
    return (
      <div>
        {vWidth < 1200 || vHeight < 900 ? <HistoryMobileNav /> : <HistoryNav />}
        <div id="top-of-history-page">
          <h1 className="history-page-title">
            HISTORY
          </h1>
          <p className="history-page-mission" style={{ fontSize: '20px', lineHeight: '30px', marginBottom: '40px' }}>
            Building a better future for our families,<br/> our communities, and our region – since 1900.
          </p>

          <div className="history-page-video-wrapper">
            <div className="history-page-video-embed">
              <iframe src="https://player.vimeo.com/video/1143977476?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" title="Graniterock Since 1900">
              </iframe>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
        </div>
        {
          historyData.map((historySectionAttributes) => 
            <HistorySection 
              {...historySectionAttributes}
              showModalThumbs={vWidth < 900 || vHeight < 900 ? false : true}
            />
          )
        }
        <div id="about-history">
          <div>
            We welcome comments, corrections and additions to our archives. Construction is an essential part of our region’s history, and we are glad to be able to share our story with you.
          </div>
          <br />
          <div>
            Now, still family owned, Graniterock locations extend from Oakland to Monterey. The values of quality, innovation and respect for people which were first established by the Company’s founder, Arthur R. Wilson, continue to lead Graniterock into the future.
          </div>
        </div>
      </div>
    )
  }
}

export default HistoryPage;